import React, { useState } from "react";

const FeatureGrid = () => {
  const [activeCard, setActiveCard] = useState(null);

  const handleCardClick = (index) => {
    setActiveCard(activeCard === index ? null : index);
  };

  const features = [
    {
      title: "All natural",
      description:
        "The only ingredients in a Calowry product are chocolate, fibre and water: The world's only solid chocolate that incorporates water!",
      icon: "🌱"
    },
    {
      title: "Non-GMO verified",
      description:
        "There is not a trace of Genetically Modified Organisms in any Calowry chocolate as it adheres to the Non-GMO verified standard",
      icon: "✓"
    },
    {
      title: "Low calorie/carb",
      description:
        "Chocolates made with Calowry are less than half the calories and net carbohydrates of conventional products.",
      icon: "⚖️"
    },
    {
      title: "Organic version",
      description:
        "Calowry is also available in 100% organic variants that are certified to the source and at every step until it reaches manufacturing.",
      icon: "🍃"
    },
    {
      title: "Plant based",
      description:
        "Every component in Calowry is readily found in natural plant sources, directly created from the Earth, with no animal content.",
      icon: "🌿"
    },
    {
      title: "Delicious",
      description:
        "You won't trade off rich chocolate taste for lower calories and net carbs as Calowry chocolate is absolutely delicious.",
      icon: "😋"
    },
    {
      title: "FDA approved",
      description:
        "Both the U.S. FDA and Health Canada have cleared the Calowry product for unrestricted general consumer consumption.",
      icon: "✓"
    },
    {
      title: "Fully patented",
      description:
        "The US Patent and Trademark Office has published Calowry's patent for exclusive application of fibre and water in chocolate.",
      icon: "📜"
    },
    {
      title: "Family owned",
      description:
        "No shares of Calowry Inc. are held by institutional or large corporate investors, strictly family, friends, and true believers.",
      icon: "👨‍👩‍👧‍👦"
    },
    {
      title: "Lower cost",
      description:
        "Almost every type of chocolate that utilizes the Calowry product reduces the overall manufacturing cost of the item.",
      icon: "💰"
    },
    {
      title: "Kosher & Halal",
      description:
        "Calowry is certified to comply with all Kosher, Pareve and Halal regulations so that all consumers can enjoy its benefits.",
      icon: "✓"
    },
    {
      title: "WE SPAN THE WORLD",
      description:
        "Calowry is a multi-national enterprise based in Canada, Australia, Thailand, and Papua New Guinea",
      icon: "🌎"
    }
  ];

  return (
    <section className="section" id="benefits">
      <div className="container">
        <div className="section-header">
          <p className="tag">Benefits at a glance</p>
          <h2 className="section-title">
            WOW! Less than half calorie/carb chocolate!
          </h2>
          <p className="section-subtitle">
            The Holy Grail of the chocolate industry has been achieved like product single innovation since the Mayan Age, WATER and fibre can now be incorporated into snappy chocolate. Calowry chocolate reduces calories, carbohydrates, and cost. It is clean, original, plant based, and proprietary not patented!
          </p>
        </div>

        <div className="feature-grid">
          {features.map((feature, index) => (
            <article 
              className={`feature-card ${activeCard === index ? 'active' : ''}`}
              key={feature.title}
              onClick={() => handleCardClick(index)}
            >
              <div className="feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeatureGrid;
